import {ActionButton, DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../../app/shared/models/campo-aggiuntivo";
import {Permission} from "../../../../app/Login/_guards/Permission";
import {dateTimeStringToFormattedDate} from "../../../Utility/DateUtility";
import {DynamicListComponent} from "../../../../app/shared/dynamic-list/dynamic-list.component";
import {forkJoin} from "rxjs";
import {ApiPathsService} from "../../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {GetFromLocalStorage, SaveToLocalStorage} from "../../../Utility/Utility";
import {GetCarrello, GetCarrelloCount, PrezzoIvato} from "./../ProductUtility";
import {data} from "jquery";
import {getOrdineDefaultSave} from "./../Ordini_Ricevuti";
import {DynamicEditComponent} from "../../../../app/shared/dynamic-edit/dynamic-edit.component";
import {FieldViewerComponent} from "../../../../app/shared/field-viewer/field-viewer.component";

function config_marketplace() {
  var OBJ: OggettoConfig = {
    Id: "config_marketplace",
    HasGet:false,
    NoSave:true,
    EditView: "Page",
    listTitle: 'Config marketplace',

    asyncMap: (
      x,
      component,
      callback
    ) => {

      x.component = component;

      ReloadMarketplace(
        x,
        component.api,
        callback
      );

    },

    campi: [

      CampoAggiuntivo.InputField(
        "",
        "campiMain",
        "",
        "col-12",
        {
          type: 'ArrayCampiAggiuntivi'
        }
      )

    ],
    Azioni: [

      ActionButton.FuncButton(
        "Salva configurazione",
        (
          x,
          api,
          onEnd
        ) => {

          SaveMarketplace(
            x,
            api,
            onEnd
          );

        },
        {
          class: 'btn btn-success cfg-market-save-btn'
        }
      )

    ],
    MenuItems: [
      {
        path: 'shared/dynamicedit/config_marketplace',
        title: "Config marketplace",
        icon: "",
        class: "",
        capacita: [],
        notruoliOperativi: ['C']
      }
    ]

  };

  return OBJ;

}
function ReloadMarketplace(
  obj,
  api,
  callback = null
) {

  forkJoin({

    categorie:
      api.ClassicPost(
        '/prodotti/categorie/list',
        {}
      ),

    stagioni:
      api.ClassicPost(
        '/prodotti/stagioni/list',
        {}
      ),

    costiCategoria:
      api.ClassicGet(
        '/progetti/costi/categoria',
        {}
      ),

    costiSpedizione:
      api.ClassicGet(
        '/progetti/costi/spedizione',
        {}
      ),

    costiBooster:
      api.ClassicGet(
        '/progetti/costi/booster',
        {}
      ),

    costiFlashSales:
      api.ClassicGet(
        '/progetti/costi/flashsales',
        {}
      ),

    costiFoto:
      api.ClassicGet(
        '/progetti/costi/foto',
        {}
      ),

    costiRetail:
      api.ClassicGet(
        '/progetti/costi/retail',
        {}
      )

  }).subscribe((res: any) => {

    obj.categorieList = res.categorie || [];

    obj.stagioniList = res.stagioni?.data || [];

    obj.costiCategoria = res.costiCategoria || [];

    obj.costiSpedizione = res.costiSpedizione || [];

    obj.costiBooster = res.costiBooster || [];

    obj.costiFlashSales = res.costiFlashSales || [];

    obj.costiFoto = res.costiFoto || [];

    obj.costiRetail = res.costiRetail || [];

    refreshLayout(obj);

    if (callback) {
      callback(obj);
    }

  });

}
function SaveMarketplace(
  x,
  api,
  onEnd = null
) {

  const checks = [];
  const stagioneConVirgola =
    (x.stagioniList || []).find(stagione => {

      const valore =
        String(
          x[`stagione_${stagione.id}`] || ""
        );

      return valore.includes(',');

    });

  if (stagioneConVirgola) {

    api.toastService.error(
      `Per "${stagioneConVirgola.check}" usa il punto invece della virgola.`
    );

    return;

  }


  const commissioneGlobale =
    (x.costiCategoria || []).find(
      c => c.id == 4
    );

  checks.push({

    id: commissioneGlobale?.id || 4,
    check: commissioneGlobale?.check || "Commissione globale (%)",
    codice: String(x.commissione_globale || "0"),
    cat_id: null,
    tipo: "a",
    ordine: commissioneGlobale?.ordine || 0

  });



  (x.categorieList || []).forEach(cat => {

    const costoCategoria =
      (x.costiCategoria || []).find(
        c => c.cat_id == cat.id
      );

    checks.push({

      id: costoCategoria?.id || null,
      check: costoCategoria?.check || `Commissione ${cat.categoria} (%)`,
      codice: String(x[`commissione_cat_${cat.id}`] || "0"),
      cat_id: cat.id,
      tipo: "a",
      ordine: costoCategoria?.ordine || 0

    });

  });



  (x.costiSpedizione || []).forEach(costo => {

    checks.push({

      id: costo.id,
      check: costo.check,
      codice: String(x[`spedizione_${costo.id}`] || "0"),
      cat_id: null,
      tipo: "s",
      ordine: costo.ordine || 0

    });

  });



  (x.costiBooster || []).forEach(costo => {

    checks.push({

      id: costo.id,
      check: costo.check,
      codice: String(x[`booster_${costo.id}`] || "0"),
      cat_id: null,
      tipo: "b",
      ordine: costo.ordine || 0

    });

  });


  (x.costiFlashSales || []).forEach(costo => {

    checks.push({
      id: costo.id,
      check: costo.check,
      codice: String(x[`flashsales_${costo.id}`] || "0"),
      cat_id: null,
      tipo: "l",
      ordine: costo.ordine || 0

    });

  });


  (x.costiFoto || []).forEach(costo => {

    checks.push({

      id: costo.id,
      check: costo.check,
      codice: String(x[`foto_${costo.id}`] || "0"),
      cat_id: null,
      tipo: "f",
      ordine: costo.ordine || 0
    });

  });

  (x.costiRetail || []).forEach(costo => {
    checks.push({
      id: costo.id,
      check: costo.check,
      codice: String(x[`retail_${costo.id}`] || "0"),
      cat_id: null,
      tipo: "r",
      ordine: costo.ordine || 0
    });

  });
  if (!x.costiRetail?.length) {

    checks.push({
      id: null,
      check: "Moltiplicatore retailer",
      codice: String(x.retail_default || "0"),
      cat_id: null,
      tipo: "r",
      ordine: 0
    });

  }

  (x.stagioniList || []).forEach(stagione => {

    checks.push({
      id: stagione.id,
      check: stagione.check,
      codice: String(x[`stagione_${stagione.id}`] || "0"),
      cat_id: null,
      tipo: "S",
      ordine: stagione.ordine || 0
    });

  });

  console.log(
    "CHECKS COMPLETI",
    checks
  );

  api.ClassicPost(
    '/progetti/costi/update',
    {
      checks: checks
    }
  ).subscribe(() => {

    api.toastService.success(
      "Configurazione salvata",
      {toastClass:'marketplace-success-toast'}
    );

  });

}
function refreshLayout(obj) {
  obj.campiMain = [
    ...LayoutMarketplace(obj)
  ];
}
function LayoutMarketplace(x) {

  const commissioneGlobale =
    (x.costiCategoria || []).find(
      c => c.id == 4
    );

  x.commissione_globale =
    commissioneGlobale?.codice || 0;

  (x.categorieList || []).forEach(cat => {

    const costoCategoria =
      (x.costiCategoria || []).find(
        c => c.cat_id == cat.id
      );

    x[`commissione_cat_${cat.id}`] =
      costoCategoria?.codice || 0;

  });

  (x.stagioniList || []).forEach(stagione => {

    x[`stagione_${stagione.id}`] =
      stagione.codice || 1;

  });


  (x.costiSpedizione || []).forEach(costo => {

    x[`spedizione_${costo.id}`] =
      costo.codice || 0;

  });
  (x.costiBooster || []).forEach(costo => {

    x[`booster_${costo.id}`] =
      costo.codice || 0;

  });

  (x.costiFlashSales || []).forEach(costo => {

    x[`flashsales_${costo.id}`] =
      costo.codice || 0;

  });

  (x.costiFoto || []).forEach(costo => {

    x[`foto_${costo.id}`] =
      costo.codice || 0;

  });
  (x.costiRetail || []).forEach(costo => {
    x[`retail_${costo.id}`] = costo.codice || 0;
  });


  return [

    CampoAggiuntivo.Html(
      "",
      `
       <div class="cfg-marketplace">

      <div class="cfg-marketplace-header">

        <div class="cfg-marketplace-title">
          ⚙️ Configurazione marketplace
        </div>

      </div>
  `,
      () => true,
      {
        class: 'col-12'
      }
    ),

    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-3 cfg-market-col",
      {
        type: "ArrayCampiAggiuntivi",

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            `
                <div class="cfg-market-card-title">
                  💵 Commissioni
                </div>

            `
          ),

          CampoAggiuntivo.TextField(
            "Commissione globale (%)",
            "commissione_globale",
            "col-12"
          ),

          ...((x.categorieList || []).map(cat =>

            CampoAggiuntivo.TextField(
              `Commissione ${cat.categoria} (%)`,
              `commissione_cat_${cat.id}`,
              "col-12"
            )

          ))

        ]

      }
    ),

    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-3 cfg-market-col",
      {
        type: "ArrayCampiAggiuntivi",

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            `

                <div class="cfg-market-card-title">
                  🚚 Spedizione
                </div>

            `
          ),

          ...((x.costiSpedizione || []).map(costo =>

            CampoAggiuntivo.TextField(
              costo.check,
              `spedizione_${costo.id}`,
              "col-12"
            )

          ))

        ]

      }
    ),
    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-3 cfg-market-col",
      {
        type: "ArrayCampiAggiuntivi",

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            `
        <div class="cfg-market-card-title">
          🏪 Moltiplicatore consumatore
        </div>

    `
          ),

          ...(x.costiRetail?.length
              ? (x.costiRetail || []).map(costo =>

                CampoAggiuntivo.TextField(
                  costo.check,
                  `retail_${costo.id}`,
                  "col-12"
                )

              )

              : [

                CampoAggiuntivo.TextField(
                  "Moltiplicatore retailer",
                  "retail_default",
                  "col-12"
                )

              ]
          ),

        ]

      }
    ),
    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-3 cfg-market-col",
      {
        type: "ArrayCampiAggiuntivi",

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            `

            <div class="cfg-market-card-title">
              🔢 Moltiplicatori stagione
            </div>

        `
          ),

          ...((x.stagioniList || []).map(stagione =>

            CampoAggiuntivo.TextField(
              `${stagione.check} (x)`,
              `stagione_${stagione.id}`,
              "col-12"
            )

          ))

        ]

      }
    ),
    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-3 cfg-market-col",
      {
        type: "ArrayCampiAggiuntivi",

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            `

            <div class="cfg-market-card-title">
              ⚡ Boost
            </div>

        `
          ),

          ...((x.costiBooster || []).map(costo =>

            CampoAggiuntivo.TextField(
              costo.check,
              `booster_${costo.id}`,
              "col-12"
            )

          ))

        ]

      }
    ),

    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-3 cfg-market-col",
      {
        type: "ArrayCampiAggiuntivi",

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            `

            <div class="cfg-market-card-title">
              🛒 Flash Sales
            </div>

        `
          ),

          ...((x.costiFlashSales || []).map(costo =>

            CampoAggiuntivo.TextField(
              costo.check,
              `flashsales_${costo.id}`,
              "col-12"
            )

          ))

        ]

      }
    ),

    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-3 cfg-market-col",
      {
        type: "ArrayCampiAggiuntivi",

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            `
            <div class="cfg-market-card-title">
              📸 Pacchetti foto
            </div>

        `
          ),

          ...((x.costiFoto || []).map(costo =>

            CampoAggiuntivo.TextField(
              costo.check,
              `foto_${costo.id}`,
              "col-12"
            )

          )),
          CampoAggiuntivo.Html(
            "",
            `</div>`,
            () => true,
            {
              class: 'col-12'
            }
          )
        ]

      }
    )


  ];

}

export var config_marketplaceEnv = () => {

  const crud =
    config_marketplace();

  return {

    Modules: {
      "config_marketplace": true
    },

    Cruds: [crud],

    Menu: [...crud.MenuItems]

  };

}
